// Import CSS
import styles from './Footer.module.css';

const Footer = () => {
  return <footer className={styles.footer}>© КП "ЦЕМ "ДОР" 2024р.</footer>;
};

export default Footer;
